import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { NormaSuprimento } from 'src/app/models/api/comercial/norma-suprimento';

@Injectable({
  providedIn: 'root'
})
export class ApiNormaSuprimentoService {
  private baseUrl = 'NormaSuprimento';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<NormaSuprimento[]>('');
  }
}
